import { render, staticRenderFns } from "./UploadMassiveComponent.vue?vue&type=template&id=636b8f92"
import script from "./UploadMassiveComponent.vue?vue&type=script&lang=js"
export * from "./UploadMassiveComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports